import React from 'react';
import Navbar from '../Navbar';
import ContactUs from '../ContactUs';
import Footer from '../Footer';

const Contact = () => {
  return (
    <div>
        <Navbar />
        <ContactUs />
        <Footer />
    </div>
  )
}

export default Contact;
